import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import SelectBox from "../../../components/shared/fields/SelectBox ";
import { useGetFruitsQuery } from "../../Receiving/unloading/unloadingApi";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import Button from "../../../components/shared/buttons/button";
import {
  useCreateProcessingEveningShiftDataMutation,
  useCreateProcessingMorningShiftDataMutation,
} from "./processingMenuApi";
import useTranslator from "../../../hooks/useTranslator";
import toast from "react-hot-toast";
import { getCurrentDate, getCurrentDateTime } from "../../../helpers/Utils";
import InputWithIcon from "../../../components/shared/fields/InputWithIcon";
import { RefreshSvg } from "../../../svgFiles/RefreshSvg";
import { MAX_TOTAL_PROCESSING_TRAY } from "../../../helpers/constants";
const ProcessingModal = ({ show, setShow, record, mode, date }) => {
  const { _t } = useTranslator();
  const todayDate = getCurrentDate("YYYY-MM-DD");
  const defaultEnteredDateTime =
    date === todayDate
      ? getCurrentDateTime("YYYY-MM-DDTHH:mm")
      : `${date}T${getCurrentDateTime("HH:mm")}`;
  const fruitTypeRecord =
    record.length > 0
      ? record?.[0]?.find((item) => item.label === "Fruit Type")?.value
      : null;

  const [createMorningRecord, { isLoading: isCreatingMorningRecord }] =
    useCreateProcessingMorningShiftDataMutation();
  const [createEveningRecord, { isLoading: isCreatingEveningRecord }] =
    useCreateProcessingEveningShiftDataMutation();
  const initialFormData = {
    carts: "",
    total_treys: "",
    striped_treys: "",
    cases_processed: "",
    fruit_type_id: "",
    kg_per_case_per_fruit: 25,
    cheeks_treys: "",
    tapitas_treys: "",
    cases_combined: "",
    cases_returned: "",
    cases_returned_total_weight: "",
    waste_cases: "",
    entered_date: date,
    entered_date_time: defaultEnteredDateTime,
  };
  const [formData, setFormData] = useState(initialFormData);
  const { data: fruitList } = useGetFruitsQuery();

  const enteredDateTimeMin = `${date}T00:00`;
  const enteredDateTimeMax =
    date === todayDate
      ? getCurrentDateTime("YYYY-MM-DDTHH:mm")
      : `${date}T${getCurrentDateTime("HH:mm")}`;

  useEffect(() => {
    setFormData(initialFormData);
  }, [mode, record, show, date]);
  const handleClose = () => {
    setShow(false);
  };

  const calculateTotalTreys = (data) => {
    return Number(data.cheeks_treys) + Number(data.striped_treys) +  Number(data.tapitas_treys);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    // prevent double submission
    if (isCreatingMorningRecord || isCreatingEveningRecord) return;

    // validate form data
    if (!formData?.fruit_type_id) {
      toast.error(_t("please_select_fruit_type", "Please select a fruit type."));
      return;
    }

    if (!formData?.cases_processed || formData?.cases_processed <= 0) {
      toast.error(_t("please_enter_valid_cases_processed", "Please enter a valid number of cases processed."));
      return;
    }

    const cheeks = Number(formData?.cheeks_treys || 0);
    const striped = Number(formData?.striped_treys || 0);

    if (cheeks + striped < MAX_TOTAL_PROCESSING_TRAY) {
      toast.error(_t("cheeks_striped_trays_min", "The total of cheeks and striped trays must be at least 24." , {max_tray: MAX_TOTAL_PROCESSING_TRAY}));
      return;
    }

    const mutation =
      mode === "addMorning" ? createMorningRecord : createEveningRecord;
    try {
      const payload = formData;
      await mutation(payload).unwrap();
      handleClose();
    } catch (error) {
      console.error("Error creating/updating manager:", error);
    }
  };

  const isInvalidInput = (value) => {
    const numericValue = parseFloat(value);
    return (
      !value ||
      isNaN(numericValue) ||
      numericValue < 0 ||
      !Number.isInteger(numericValue)
    );
  };

  const handleChange = (e) => {
    let { name, value } = e.target;
    
    // Handle carts field - allow decimal with 2 decimal places
    if (name === "carts") {
      // Allow empty value
      if (value === "") {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        }));
        return;
      }
      
      // Parse as float
      const numericValue = parseFloat(value);
      
      // Validate it's a valid number and not negative
      if (isNaN(numericValue) || numericValue < 0) {
        return; // Don't update if invalid
      }
      
      // Limit to 2 decimal places
      const decimalParts = value.split('.');
      if (decimalParts[1] && decimalParts[1].length > 2) {
        value = parseFloat(value).toFixed(2);
      }
    }
    // Handle integer fields
    else if (
      name === "cases_processed" ||
      name === "cheeks_treys" ||
      name === "striped_treys" ||
      name === "tapitas_treys" ||
      name === "cases_combined" ||
      name === "cases_returned" ||
      name === "waste_cases"
    ) {
      value = isInvalidInput(value) ? 0 : parseInt(value, 10);
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    // console.log(`Tapitas updated`);
    let totalTreys =
      Number(formData.cheeks_treys) + Number(formData.striped_treys) + Number(formData.tapitas_treys);
      // console.log(totalTreys)
    
    //  Need to confirm this check 
    
    // if (mode === "addEvening") {
    //   totalTreys += formData?.cases_combined;
    // }
    // const totalCarts = Math.ceil(totalTreys / 26);
    const totalCarts = Number((totalTreys / 26).toFixed(2));    
    setFormData((prev) => ({
      ...prev,
      total_treys: totalTreys,
      carts: totalCarts > 0 ? totalCarts : "",
    }));
  }, [
    formData?.cheeks_treys,
    formData?.striped_treys,
    formData?.tapitas_treys,
    formData?.cases_combined,
  ]);

  const renderFormFields = () => {
    return mode === "addMorning" || mode === "editMorning" ? (
      <>
        <Col lg={6}>
          <InputWithLabel
            label={_t("entered_date_time", "Entered Date Time")}
            type="datetime-local"
            name="entered_date_time"
            value={formData.entered_date_time}
            onChange={handleChange}
            placeholder={_t("date", "Date")}
            min={enteredDateTimeMin}
            max={enteredDateTimeMax}
            disabled={true}
          />
        </Col>
        <Col lg={6}>
          <SelectBox
            label={_t("fruit_type", "Fruit Type")}
            name="fruit_type_id"
            options={fruitList?.data.map((list) => ({
              value: list.id,
              label: _t(list.name, list.name),
              disabled:
                fruitTypeRecord !== null && list.name === fruitTypeRecord,
            }))}
            value={formData.fruit_type_id}
            required={false}
            onChange={handleChange}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("cases_processed", "Cases Processed")}
            type="number"
            name="cases_processed"
            value={formData.cases_processed}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>
        {/* <Col lg={6}>
          <InputWithLabel
            label={_t("kg_per_case", "KG Per Case Per Fruit")}
            type="number"
            name="kg_per_case_per_fruit"
            value={formData.kg_per_case_per_fruit}
            onChange={handleChange}
            placeholder={"0"}
            disabled={true}
          />
        </Col> */}
        <Col lg={6}>
          <InputWithLabel
            label={_t("cheeks_treys", "Cheeks Treys")}
            type="number"
            name="cheeks_treys"
            value={formData.cheeks_treys}
            onChange={handleChange}
            placeholder={"0"}            
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("striped_treys", "Striped Treys")}
            type="number"
            name="striped_treys"
            value={formData.striped_treys}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("tapitas_treys", "Tapitas Treys")}
            type="number"
            name="tapitas_treys"
            value={formData.tapitas_treys}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("total_treys", "Total Treys")}
            type="number"
            name="total_treys"
            value={calculateTotalTreys(formData)}
            onChange={handleChange}
            disabled={true}
            placeholder={"0"}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("carts", "Carts")}
            type="number"
            name="carts"
            value={formData.carts}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>
      </>
    ) : (
      <>
        <Col lg={6}>
          <InputWithLabel
            label={_t("entered_date_time", "Entered Date Time")}
            type="datetime-local"
            name="entered_date_time"
            value={formData.entered_date_time}
            onChange={handleChange}
            placeholder={_t("date", "Date")}
            min={enteredDateTimeMin}
            max={enteredDateTimeMax}
            disabled={true}
          />
        </Col>
        <Col lg={6}>
          <SelectBox
            label={_t("fruit_type", "Fruit Type")}
            name="fruit_type_id"
            options={fruitList?.data.map((list) => ({
              value: list.id,
              label: _t(list.name, list.name),
              disabled:
                fruitTypeRecord !== null && list.name === fruitTypeRecord,
            }))}
            value={formData.fruit_type_id}
            required={false}
            onChange={handleChange}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("cases_processed", "Cases Processed")}
            type="number"
            name="cases_processed"
            value={formData.cases_processed}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>
        {/* <Col lg={6}>
          <InputWithLabel
            label={_t("kg_per_case", "KG Per Case Per Fruit")}
            type="number"
            name="kg_per_case_per_fruit"
            value={formData.kg_per_case_per_fruit}
            onChange={handleChange}
            disabled={true}
            placeholder={"0"}
          />
        </Col> */}
        <Col lg={6}>
          <InputWithLabel
            label={_t("cheeks_treys", "Cheeks Treys")}
            type="number"
            name="cheeks_treys"
            value={formData.cheeks_treys}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("striped_treys", "Striped Treys")}
            type="number"
            name="striped_treys"
            value={formData.striped_treys}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("tapitas_treys", "Tapitas Treys")}
            type="number"
            name="tapitas_treys"
            value={formData.tapitas_treys}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("total_treys", "Total Treys")}
            type="number"
            name="total_treys"
            value={calculateTotalTreys(formData)}
            onChange={handleChange}
            disabled={true}
            placeholder={"0"}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("carts", "Carts")}
            type="number"
            name="carts"
            value={formData.carts}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("cases_combined", "Cases Combined")}
            type="number"
            name="cases_combined"
            value={formData.cases_combined}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>
        <Col lg={6}>
          <InputWithLabel
            label={_t("cases_returned", "Cases Returned")}
            type="number"
            name="cases_returned"
            value={formData.cases_returned}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>
        <Col lg={6}>
          <InputWithIcon
            label={_t(
              "cases_returned_total_weight",
              "Cases Returned Total Weight"
            )}
            type="number"
            name="cases_returned_total_weight"
            value={formData.cases_returned_total_weight}
            onChange={handleChange}
            placeholder={"0"}
            icon={RefreshSvg}
            className={"cmn_input"}
          />
        </Col>

        <Col lg={6}>
          <InputWithLabel
            label={_t("waste_cases", "Waste Cases")}
            type="number"
            name="waste_cases"
            value={formData.waste_cases}
            onChange={handleChange}
            placeholder={"0"}
          />
        </Col>
        <Col lg={6}>
          <InputWithIcon
            label={_t("waste_cases_kg", "Waste Cases Weight (Kg)")}
            type="number"
            name="waste_cases_weight"
            value={formData.waste_cases_weight}
            onChange={handleChange}
            icon={RefreshSvg}
            className={"cmn_input"}
            placeholder={"0"}
          />
        </Col>
      </>
    );
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "addMorning" || mode === "editMorning"
          ? "Morning Shift Log"
          : "Evening Shift Log"
      }
      children={formData}
    >
      <Row>{renderFormFields()}</Row>

      <Row>
        <Col className="text-end">
          <Button
            label={_t("save_changes", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            disabled={isCreatingMorningRecord || isCreatingEveningRecord}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default ProcessingModal;
